(function () {
  'use strict';

  var root = document.documentElement;
  var reduced = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function armRelayInteraction(scope) {
    scope.querySelectorAll('.phl1-relay').forEach(function (relay) {
      if (relay.hasAttribute('data-phl1-interaction-ready')) return;
      relay.setAttribute('data-phl1-interaction-ready', '');

      var routes = Array.prototype.slice.call(relay.querySelectorAll('[data-phl1-route]'));
      if (!routes.length) return;

      function setActiveRoute(routeName) {
        if (routeName) relay.setAttribute('data-route-active', routeName);
        else relay.removeAttribute('data-route-active');
      }

      function setPinnedRoute(routeName) {
        if (routeName) relay.setAttribute('data-route-pinned', routeName);
        else relay.removeAttribute('data-route-pinned');
        routes.forEach(function (route) {
          route.setAttribute(
            'aria-pressed',
            route.getAttribute('data-phl1-route') === routeName ? 'true' : 'false'
          );
        });
      }

      function restorePinnedRoute() {
        setActiveRoute(relay.getAttribute('data-route-pinned') || '');
      }

      routes.forEach(function (route) {
        var routeName = route.getAttribute('data-phl1-route');

        route.addEventListener('pointerenter', function () {
          setActiveRoute(routeName);
        });

        route.addEventListener('pointerleave', restorePinnedRoute);

        route.addEventListener('focus', function () {
          setActiveRoute(routeName);
        });

        route.addEventListener('blur', restorePinnedRoute);

        route.addEventListener('click', function () {
          var shouldClear = relay.getAttribute('data-route-pinned') === routeName;

          if (shouldClear) {
            setPinnedRoute('');
            setActiveRoute('');
            return;
          }

          setPinnedRoute(routeName);
          setActiveRoute(routeName);
        });
      });

      relay.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape' || (
          !relay.hasAttribute('data-route-active') &&
          !relay.hasAttribute('data-route-pinned')
        )) return;
        setPinnedRoute('');
        setActiveRoute('');
        event.preventDefault();
      });
    });
  }

  armRelayInteraction(document);

  /* These sections do not own an entrance animation. Interactive sections keep their
     local behavior; this one observer replaces the former page-wide GSAP/ScrollTrigger layer. */
  var revealSelectors = [
    '.ptl1-head',
    '.ptl1-ledger',
    '.section-economical-price .section-header',
    '.section-economical-price .pricing-toggle-wrap',
    '.section-economical-price .eco-universals',
    '.section-economical-price .economic--price-grid',
    '.pss-left',
    '.pss-panel'
  ].join(',');

  if (!reduced && 'IntersectionObserver' in window) {
    var hero = document.querySelector('.phl1');
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.target === hero) {
          hero.classList.toggle('phl1-flow-off', !entry.isIntersecting);
          return;
        }
        if (!entry.isIntersecting) return;
        entry.target.classList.add('pc-reveal-in');
        revealObserver.unobserve(entry.target);
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -7% 0px'
    });

    function armReveals(scope) {
      var targets = Array.prototype.slice.call(scope.querySelectorAll(revealSelectors));
      var groupCounts = new Map();

      targets.forEach(function (target) {
        if (target.hasAttribute('data-pc-reveal')) return;
        var group = target.closest('.shopify-section') || target.parentElement;
        var index = groupCounts.get(group) || 0;
        groupCounts.set(group, index + 1);
        target.setAttribute('data-pc-reveal', '');
        target.style.setProperty('--pc-reveal-delay', Math.min(index * 65, 195) + 'ms');
        revealObserver.observe(target);
      });
    }

    armReveals(document);
    if (hero) revealObserver.observe(hero);
    root.classList.add('pc-motion-ready');

    document.addEventListener('visibilitychange', function () {
      root.classList.toggle('pc-page-hidden', document.hidden);
    });

    document.querySelectorAll('[data-phl1-motion-toggle]').forEach(function (button) {
      button.addEventListener('click', function () {
        var heroSection = button.closest('.phl1');
        if (!heroSection) return;
        var paused = heroSection.classList.toggle('phl1-user-paused');
        button.setAttribute('aria-pressed', paused ? 'true' : 'false');
        var label = button.querySelector('[data-phl1-motion-label]');
        if (label) label.textContent = paused ? 'Play motion' : 'Pause motion';
      });
    });

    document.addEventListener('shopify:section:load', function (event) {
      armReveals(event.target);
      armRelayInteraction(event.target);
    });
  }
})();
